import VueRouter from "vue-router";
import { setVueRouter } from "./proxy";

const RouterService = {
  install(vue) {
    vue.use(VueRouter);
    const routes = [];
    const routesContexts = require.context("@/router", true, /\.js$/);
    routesContexts
      .keys()
      .forEach((name) => routes.push(...routesContexts(name).default));

    this.router = new VueRouter({
      routes,
    });

    setVueRouter(this.router);
  },
  router: null
};

export default RouterService;
